export default function isMediaVideo(item) {
  const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv', 'flv', 'wmv', 'm4v', 'mpeg', 'mpg'];
  const extension = item.split('.').pop().toLowerCase();
  return videoExtensions.includes(extension);
}